import React, { useEffect } from 'react';
import { getPriceMap, PriceMap } from 'api/get';
import SelectPlanModal from './SelectPlanModal';
import PaymentInfoModal from './PaymentInfoModal';

type SelectUpgradePlanModalProps = {
  closeModal: () => void;
  visible: boolean;
};
type ModalState = 'selectPlan' | 'paymentInfo';

const SelectUpgradePlanModal: React.FC<SelectUpgradePlanModalProps> = ({
  closeModal,
  visible,
}) => {
  const [modalState, setModalState] = React.useState<ModalState>('selectPlan');

  const [priceMap, setPriceMap] = React.useState<PriceMap | null>(null);

  const fetchData = async () => {
    const data = await getPriceMap();
    setPriceMap(data);
  };

  const handleClose = () => {
    setModalState('selectPlan');
    closeModal();
  };

  useEffect(() => {
    if (visible) fetchData();
  }, [visible]);

  if (!priceMap || !visible) return null;

  return modalState === 'selectPlan' ? (
    <SelectPlanModal
      closeModal={handleClose}
      onOk={() => setModalState('paymentInfo')}
      perAgentPrice={priceMap.perAgentPrice}
    />
  ) : (
    <PaymentInfoModal
      closeModal={handleClose}
      goBack={() => setModalState('selectPlan')}
      priceMap={priceMap}
    />
  );
};

export default SelectUpgradePlanModal;
